export const VIP_OFFER_THRESHOLD = 300

export function recommendedPlanFromOfferCount(
  totalOffers: number | null | undefined,
): 'STANDARD' | 'VIP' | null {
  if (totalOffers == null) return null
  return totalOffers >= VIP_OFFER_THRESHOLD ? 'VIP' : 'STANDARD'
}
